const CARDS = [
  {
    title: '极限追凶',
    tag: '动作 / 犯罪',
    rating: '9.2',
    desc: '硬汉刑警深入犯罪都市，一场生死时速的终极对决即将展开。全程高能打斗，肾上腺素飙升之作。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20action%20movie%20scene%20with%20intense%20police%20chase%20through%20rainy%20city%20streets%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20asphalt%2C%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20warm%20golden%20and%20cool%20blue%20contrast%20tones%2C%20cinematic%20composition&width=600&height=400&seq=card-movie-01&orientation=landscape',
    accent: true,
  },
  {
    title: '笑花开局',
    tag: '喜剧 / 剧情',
    rating: '8.9',
    desc: '一段荒诞搞笑的创业之旅，笑中带泪的精彩演绎，让您从头笑到尾又回味无穷。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20comedic%20movie%20scene%20with%20warm%20lighting%2C%20modern%20office%20setting%20with%20colorful%20decor%2C%20lighthearted%20atmosphere%2C%20soft%20golden%20hour%20light%20streaming%20through%20windows%2C%20cinematic%20warm%20tones&width=600&height=400&seq=card-movie-02&orientation=landscape',
    accent: false,
  },
  {
    title: '星际征途：新纪元',
    tag: '科幻 / 冒险',
    rating: '8.7',
    desc: '人类文明的最后希望，在浩瀚星海中寻找新家园。震撼视觉特效，深度思考之作。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20movie%20scene%20with%20massive%20spaceship%20orbiting%20a%20distant%20planet%2C%20nebula%20clouds%20in%20deep%20space%2C%20dramatic%20cosmic%20lighting%2C%20warm%20amber%20and%20deep%20indigo%20color%20palette%2C%20cinematic%20widescreen%20composition&width=600&height=400&seq=card-movie-03&orientation=landscape',
    accent: false,
  },
  {
    title: '暗夜追踪者',
    tag: '悬疑 / 惊悚',
    rating: '8.5',
    desc: '连环案件背后的惊人真相，每一个细节都暗藏玄机。烧脑反转不断，结局令人震撼。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20movie%20scene%20with%20detective%20silhouette%20in%20dimly%20lit%20alley%2C%20fog%20and%20shadows%2C%20single%20streetlamp%20casting%20dramatic%20light%2C%20noir%20aesthetic%2C%20warm%20amber%20light%20in%20darkness%2C%20cinematic%20atmosphere&width=600&height=400&seq=card-movie-04&orientation=landscape',
    accent: true,
  },
  {
    title: '武林风云录',
    tag: '动作 / 武侠',
    rating: '8.3',
    desc: '江湖恩怨，刀光剑影。一部致敬经典武侠的动作巨制，拳拳到肉的打斗场面令人热血沸腾。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20movie%20scene%20with%20warriors%20in%20traditional%20robes%20on%20misty%20mountain%20peak%2C%20golden%20sunset%20light%2C%20dramatic%20clouds%2C%20epic%20widescreen%20cinematography%2C%20warm%20earthy%20tones%20with%20golden%20highlights&width=600&height=400&seq=card-movie-05&orientation=landscape',
    accent: false,
  },
  {
    title: '欢乐一家人',
    tag: '喜剧 / 家庭',
    rating: '8.1',
    desc: '三代同堂的爆笑日常，每个家庭都能找到自己的影子。温馨治愈，笑料百出。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20family%20comedy%20movie%20scene%20with%20multi%20generation%20family%20gathered%20around%20dinner%20table%2C%20cozy%20home%20interior%2C%20warm%20golden%20lighting%2C%20laughter%20and%20joy%2C%20soft%20cinematic%20photography%2C%20comfortable%20atmosphere&width=600&height=400&seq=card-movie-06&orientation=landscape',
    accent: false,
  },
  {
    title: '深海危机',
    tag: '动作 / 灾难',
    rating: '7.9',
    desc: '深海钻井平台遭遇灭顶之灾，极限环境下的人性考验。惊心动魄的灾难场面，视觉冲击力拉满。',
    img: 'https://readdy.ai/api/search-image?query=Intense%20disaster%20movie%20scene%20with%20deep%20sea%20oil%20rig%20in%20storm%2C%20massive%20waves%20crashing%2C%20dark%20dramatic%20skies%2C%20emergency%20lights%20glowing%20red%2C%20cinematic%20action%20composition%2C%20high%20contrast%20lighting&width=600&height=400&seq=card-movie-07&orientation=landscape',
    accent: false,
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-2">编辑团队为您精心挑选的优质影片</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {CARDS.map((card) => (
            <a
              key={card.title}
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden hover:border-primary-500/40 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.img}
                  alt={`97影视 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent pointer-events-none" />
                <div className="absolute top-2 right-2">
                  <span className={`px-2 py-0.5 text-[10px] font-semibold rounded ${
                    card.accent
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-primary-500 text-background-50'
                  }`}>
                    {card.rating}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                    {card.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-400 mb-2">{card.tag}</p>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}